/**
 * @method removeSvgCovers
 */
const removeSvgCovers = (frame) => {
  if (!frame) {
    return;
  }
  const contentDocument = frame.contentDocument;
  let svgCover;
  let svgCoverElement = () => {
    svgCover = contentDocument.querySelector('.svgCover');
    return svgCover;
  };

  while (svgCoverElement()) {
    const parentElement = svgCover.parentElement;
    parentElement.removeChild(svgCover);
    parentElement.normalize();
  }
};

export default removeSvgCovers;
